import { createStyles } from '@asuikit/styles';

export default createStyles(() => ({
  wrapper: {
    position: 'relative',
  },
}));
